import { type OverlayTriggerProps, useOverlayTrigger } from "react-aria";
import { type OverlayTriggerProps as OverlayTriggerStateProps, useOverlayTriggerState } from "react-stately";

export const useOverlay = (options: OverlayTriggerStateProps = {}, type: OverlayTriggerProps["type"] = "dialog") => {
  const state = useOverlayTriggerState(options);
  const { triggerProps, overlayProps } = useOverlayTrigger({ type }, state);

  return { state, triggerProps, overlayProps };
};
